import * as React from 'react';
import './ReturnsCartModal.scss';
import Modal from 'src/components/common/Modal';
import ReturnsOptions from './components/ReturnsOptions';
import ReturnsTable from './components/ReturnsTable';
import ShippingOptions from './components/ShippingOptions';
import DistributionOptions from './components/DistributionOptions';
import BoxInfo from './components/BoxInfo';
import DropOffStore from './components/DropOffStore';
import SelfShipping from './components/SelfShipping';
import BoxConfirm from './components/BoxConfirm';
import SaveForLaterConfirm from './components/SaveForLaterConfirm';
import Button from 'src/components/common/Button';
import cartService from 'src/services/cart/CartService';
import locationServiceInstance from 'src/services/location/LocationService';
import { RMA_EDIT, IRmaModalData, RMA_SUBMIT } from '../../ReturnsView';
import {
  IEligibleItem,
  IReturnOptionConfig,
  IStatusFilter,
  IReturnGenerateShippingLabel,
  IReturnGenerateShippingLabelResponse,
  IReturnShippingConfig,
  IReturnSubmittedOption
} from 'src/services/returns/typings';
import {
  ADD_EXISTING,
  ADD_NEW,
  SAVE_FOR_LATER,
  SUBMIT_NOW
} from './components/ReturnsOptions/ReturnsOptions';
import { ERmaStatus } from '../StatusTab/StatusTab';
import hasComma from 'src/utils/hasComma';
import { useRef } from 'react';

interface IReturnsCartModalProps {
  closeModal: () => void;
  partsToReturn: IEligibleItem[];
  rmaList: string[];
  removePartFromReturnList: (id: number) => void;
  editPartFromReturnList: (part: IEligibleItem) => void;
  onSaveForLater: (config: IReturnOptionConfig, callback?: () => void) => void;
  onSubmitNow: (
    config: IReturnShippingConfig,
    callback?: (rmaNumber: string) => void
  ) => void;
  onUpdateNow: (
    config: IReturnShippingConfig,
    callback?: (rmaNumber: string,resUpsCharges:IReturnGenerateShippingLabelResponse) => void
  ) => void;
  handleOpenBarcodeModal: (rmaNumber: string,upsResponseData:any[]) => void;
  getStatusItems: (body?: IStatusFilter) => void;
  typeOfItemEligible: string;
  getRMALists: (body?: IStatusFilter) => void;
  filters: {
    status: string;
    search: any;
  };
  clearStatusFilters: () => void;
  clearEligibleFilters: () => void;
  showSubmitAlert: (rmaNumber: string) => void;
  userData:any;
  handleShippingLabelErrorMessageForPrintPopup: (shippingErrorMessage: string) => void;
  isCloseModalIfError: boolean;
  t?: any;
}

const ReturnsCartModal: React.FC<IReturnsCartModalProps> = props => {
  const {
    closeModal,
    partsToReturn,
    rmaList,
    removePartFromReturnList,
    editPartFromReturnList,
    onSaveForLater,
    onSubmitNow,
    onUpdateNow,
    handleOpenBarcodeModal,
    getStatusItems,
    typeOfItemEligible,
    getRMALists,
    filters,
    clearStatusFilters,
    clearEligibleFilters,
    showSubmitAlert,
    userData,
    handleShippingLabelErrorMessageForPrintPopup,
    isCloseModalIfError,
    t
  } = props;

  const [selectedOption, setSelectedOption] = React.useState<string>(
    ADD_EXISTING
  );
  const [poNumber, setPoNumber] = React.useState('');
  const [rmaSelected, setRmaSelected] = React.useState('');
  const [shippingTabToShow,setShippingTabToShow]=React.useState(true);
  const [checkShippingOtiopn,setCheckShippingOption]=React.useState(true);
  const [shippingSelectedOption, setShippingSelectedOption] = React.useState('');
  const [distributionSelectedOption, setDistributionSelectedOption] = React.useState('');
  const [tabTitle,setTabTitle]=React.useState('Shipping Options');
  const [tabBackButtonText,setTabBackButtonText]=React.useState('');
  const [shppingType,setShippingType]=React.useState('');
  const [storeList,setStoreList]=React.useState([]);
  const [isLoader,setIsLoader]=React.useState(false);
  const [confirmBox,setConfirmBox]=React.useState(false);
  const [upsResponseData,setupsResponseData]=React.useState([]);
  const [upsTotalShippingCharge,setupsResponseTotal]=React.useState<number>(0);
  const [submitButtonEnabled,setsubmitButtonEnabled]=React.useState<number>(1);
  const [preSaveForLaterAlt, setPreSaveForLaterAlt] = React.useState<boolean>(false);
  const [totalItemPrice, setTotalAddedItemPrice] = React.useState<number>(0);
  
  const [selfShippingWarehouseCode, setSelfShippingWarehouseCode] = React.useState('');
  const [warehouseCodeVal, setWarehouseCode] = React.useState('');
  const [toShippingWarehouseCode, setToShippingWarehouseCode] = React.useState('');
  const [shppingTypeVal,setShippingTypeVal]=React.useState('');
  const [trackingNumbersVal,setTrackingNumbers]=React.useState([]);
  const [upsErrorMessage,setUpsErrorMessage]=React.useState('');
  const [shippingLabelRequest, setShippingLabelRequest]=React.useState([]);
  
  const ref = useRef(null);

  React.useEffect(() => {
    setRmaSelected(rmaList.length > 0 && rmaList[0]);

    if (rmaList.length > 0) {
      setSelectedOption(ADD_EXISTING);
    } else {
      setSelectedOption(ADD_NEW);
    }
  }, [rmaList]);

  React.useEffect(() => {
    if(isCloseModalIfError===true){
      closeModal();
    }
  }, [isCloseModalIfError]);


  

  React.useEffect(() => {
    if (typeOfItemEligible === 'usedCore') {
      setSelectedOption(ADD_NEW);
    }
 
  }, []);

   React.useEffect(() => {
     /* Calculate total added item price */
     let totalAddedItemPrice=0;
     if(partsToReturn.length>0){
     partsToReturn.map((res)=>{
       let priceWithQtyCal=res.price*res.returnQuantity;
       let priceAsRestockingFee=0;
       if (typeOfItemEligible === 'usedCore') {
        if(res.returnFee>0){
          priceAsRestockingFee=(res.price*res.returnFee/100);
        }else{
          priceAsRestockingFee=0;
        }
      }else{
        priceAsRestockingFee=(res.price*res.returnFee/100);
      }
       priceWithQtyCal=priceWithQtyCal-priceAsRestockingFee;
       totalAddedItemPrice=totalAddedItemPrice+priceWithQtyCal;
     });
     setTotalAddedItemPrice(totalAddedItemPrice);
    }
  }, [partsToReturn]);

  const styles = {
    width: '85%'
  };

  const handleSelectedRma = (value: string) => {
    setRmaSelected(value);
  };

  const handlePoNumber = (e: any) => {
    if (!hasComma(e.target.value)) {
      setPoNumber(e.target.value);
    }
  };

  const handleChangeOption = (e: any) => {
    if (rmaList.length > 0) {
      setSelectedOption(e.target.value);
    }
  };


  const getAddresses = async (
    postalCode: string,
    value?: boolean
  ) => {
    const newStoreList: any[] = [];

    newStoreList.push({
      code: '0',
      name: 'Select',
      addr: 'warehouse'
    });

    await locationServiceInstance
      .getLocations(postalCode, value)
      .then(addresses => {
        addresses.forEach((address: any) => {
          newStoreList.push({
            code: address.code,
            name: address.name,
            addr: address.addressLine1
          });
        });
      });

    return newStoreList;
  };

  const getStoreList=async()=>{
    let deliveryAddresses: any[] = [];
    await cartService.getCartShippingAddress().then(async r => {
      deliveryAddresses = await getAddresses(
        r.deliveryLocation.postalCode,
        false
      );
      setStoreList(deliveryAddresses);
      setIsLoader(false);
    });
    
  };

  const handleShippingChangeOption = (e: any) => {
      setShippingSelectedOption(e.target.value);
      
      /* Drop Off at Store Clicked */
      if(e.target.value==="dropOffAtStore"){
        setIsLoader(true);
        setCheckShippingOption(true);
        getStoreList();
        
      }else{
        setCheckShippingOption(false);
        setTabTitle('SHIP TO DISTRIBUTION CENTER ');
        setTabBackButtonText('Back to Shipping Option');
        setShippingType('INDISTRIBUTIONSCREEN');
      }
      
  };

  const handleDistributionChangeOption = (e: any) => {
    if(e.target.value==="selfShipping"){
      setIsLoader(true);
      getStoreList();
      setWarehouseCode('0');
      setShippingTypeVal('');
      setsubmitButtonEnabled(1);
    }else{
      setSelfShippingWarehouseCode('0');
      setShippingTypeVal('');
      setsubmitButtonEnabled(1);
    }
    setDistributionSelectedOption(e.target.value);
  };

  const handleBackButtion = () => {
    if(shppingType==="INDISTRIBUTIONSCREEN"){
      /* Back To Shiiping Option */
      setShippingSelectedOption('');
      setDistributionSelectedOption('');
      setCheckShippingOption(true);
      setTabTitle('SHIPPING OPTIONS');
      setTabBackButtonText('');
    }
  };

  

  const isDisabled = (): boolean => {
    return (
      submitButtonEnabled===1 || (rmaList.length === 0 && selectedOption === ADD_EXISTING) || partsToReturn.length === 0
      /* (rmaList.length === 0 && selectedOption === ADD_EXISTING) ||
      partsToReturn.length === 0*/
    );
  };

  const isDisabledLater = (): boolean => {
    return (
      (rmaList.length === 0 && selectedOption === ADD_EXISTING) ||
      partsToReturn.length === 0
    );
  };

  const handlePreSaveForLater=()=>{
    setPreSaveForLaterAlt(true);
    setCheckShippingOption(false);
  }

  const handleSaveForLater = () => {
    closeModal();
    onSaveForLater(
      {
        type: selectedOption,
        rmaNumber: rmaSelected,
        poNumber,
        items: partsToReturn,
        submissionType: SAVE_FOR_LATER
      },
      () => {
        clearStatusFilters();
        clearEligibleFilters();
        getStatusItems({
          itemType: typeOfItemEligible === 'part' ? 'PART' : 'CORE'
        });
        getRMALists({
          itemType: typeOfItemEligible === 'part' ? 'PART' : 'CORE',
          rmaListStatus: ERmaStatus.NOT_SUBMITTED
        });
        closeModal();
      }
    );
  };
   const handleSubmitNow = () => {
    let selectedWarehouseCode='';
    if(shppingTypeVal==="DROP_OFF_STORE"){
      selectedWarehouseCode=warehouseCodeVal;
    }else if(shppingTypeVal==="SELF_SHIPPING"){
      selectedWarehouseCode=selfShippingWarehouseCode
    }
    // closeModal();
    /* Create shipping lable with RMA on it */
    if(distributionSelectedOption==="purchasePrepaidShipping"){
      onUpdateNow(
        {
          type: selectedOption,
          rmaNumber: rmaSelected,
          poNumber,
          items: partsToReturn,
          submissionType: SUBMIT_NOW,
          shippingType:shppingTypeVal,
          shippingLabelRequest
        },
        (rmaNumber: string,resUpsCharges: IReturnGenerateShippingLabelResponse) => {
          if (resUpsCharges.message !== null) {
            setIsLoader(false);
            setUpsErrorMessage(resUpsCharges.message);
            handleShippingLabelErrorMessageForPrintPopup(resUpsCharges.message);
            handleOpenBarcodeModal(rmaNumber, []);
          }else{
            setUpsErrorMessage('');
            // setConfirmBox(true);
            setupsResponseData(resUpsCharges.shippingLabelExtendedInfo);
            handleOpenBarcodeModal(rmaNumber, resUpsCharges.shippingLabelExtendedInfo);
            setupsResponseTotal(parseFloat(resUpsCharges.total));
          }
          clearStatusFilters();
          clearEligibleFilters();
          getStatusItems({
            itemType: typeOfItemEligible === 'part' ? 'PART' : 'CORE'
          });
          getRMALists({
            itemType: typeOfItemEligible === 'part' ? 'PART' : 'CORE',
            rmaListStatus: ERmaStatus.NOT_SUBMITTED
          });
            closeModal();
            showSubmitAlert(rmaNumber);
            setCheckShippingOption(false);
            setShippingSelectedOption('')
            setTabTitle('CONFIRMATION');
            setTabBackButtonText('');
           // setIsLoader(false);
            // closeModal();
          
        }
      );

    }else{
    onSubmitNow(
      {
        type: selectedOption,
        rmaNumber: rmaSelected,
        poNumber,
        items: partsToReturn,
        submissionType: SUBMIT_NOW,
        shippingType:shppingTypeVal,
        warehouseCode:selectedWarehouseCode
      },
      (rmaNumber: string) => {
        clearStatusFilters();
        clearEligibleFilters();
        getStatusItems({
          itemType: typeOfItemEligible === 'part' ? 'PART' : 'CORE'
        });
        getRMALists({
          itemType: typeOfItemEligible === 'part' ? 'PART' : 'CORE',
          rmaListStatus: ERmaStatus.NOT_SUBMITTED
        });
        // closeModal();
          showSubmitAlert(rmaNumber);
          handleOpenBarcodeModal(rmaNumber, []);
          setCheckShippingOption(false);
          setShippingSelectedOption('')
          setTabTitle('CONFIRMATION');
          setTabBackButtonText('');
          setIsLoader(false);
          closeModal();
      }
    );
  }
  };

  /* Send Shiiping Lable Request Parameters */
  const handleGenerateShippingLabel = (upsBox:any) => {
    ref.current?.scrollIntoView({behavior: 'smooth'});
    setsubmitButtonEnabled(2);
    setShippingLabelRequest(upsBox);
    setShippingTypeVal('PREPAID_SHIPPING');
  }

  const handleConfirmationCancel=()=>{
    setCheckShippingOption(true);
    setShippingSelectedOption('')
    setTabTitle('CONFIRMATION');
    setTabBackButtonText('');
    setShippingSelectedOption('');
    setDistributionSelectedOption('');
    setTabTitle('SHIPPING OPTIONS');
    setTabBackButtonText('');
    setConfirmBox(false);
    setShippingTypeVal('');
  }
  const handleBoxeChange=(e:any)=>{
    if(e===false){
      setsubmitButtonEnabled(1);
    }
  }

  // UPS confirmation 
  const handleUpsConfirmation=()=>{
    setsubmitButtonEnabled(2);
    setSelfShippingWarehouseCode('0');
    setWarehouseCode('0');
    setShippingTypeVal('PREPAID_SHIPPING');
  }

  // Select DropOff warehouse and reset - Shipping Warehouse, Shipping Label
  const handleDropOffWarehouse=(dropOffWarehouse:string)=>{
    if(dropOffWarehouse==='0'){
      setsubmitButtonEnabled(1);
    }else{
     setWarehouseCode(dropOffWarehouse);
     setSelfShippingWarehouseCode('0');
     setsubmitButtonEnabled(2);
     setShippingTypeVal('DROP_OFF_STORE');
    }
   }
   
   // Select Self Shipping warehouse
   const handleSelfShippingWarehouse=(selfSAhippingWarehouseCode:any)=>{
    if(selfSAhippingWarehouseCode==='0'){
      setsubmitButtonEnabled(1);
    }else{
    setSelfShippingWarehouseCode(selfSAhippingWarehouseCode);
    setWarehouseCode('0');
    setsubmitButtonEnabled(2);
    setShippingTypeVal('SELF_SHIPPING');
    }
   }  

  return (
    <div className="rp-returns-cart-modal shipping-content">
      <Modal handleCloseModal={closeModal} showClose={false} styles={styles}>
        <div className="rp-returns-cart-modal-container">
          <div className="rp-returns-cart-modal-header">
            <h3>{t('myReturns.returnsCart')}</h3>
            <i className="rpds-close" onClick={closeModal} />
          </div>
          <div className="rp-returns-cart-modal-components">
            <ReturnsOptions
              rmaList={rmaList}
              selectedOption={selectedOption}
              handleChangeOption={handleChangeOption}
              handlePoNumber={handlePoNumber}
              rmaSelected={rmaSelected}
              poNumber={poNumber}
              handleSelectedRma={handleSelectedRma}
            />

            <ReturnsTable
              partsToReturn={partsToReturn}
              removeItemFromReturn={removePartFromReturnList}
              editPartFromReturnList={editPartFromReturnList}
            />
            {shippingTabToShow && 
            <div className="return-shipping-row">
              <div className="col">
                <div className="rp-return-details-desktop--tabs-container-cart-modal">
                  <div className="rp-tabs">
                    <div className="rp-return-tabs--tab-cart-modal">
                      <div>{tabTitle}</div>
                      <div className="tab-back-btn-text" onClick={handleBackButtion}>{tabBackButtonText}</div>
                    </div>
                      <div className="rp-tabs--content">
                        <div className="rp-pick-up-tab--info">
                          <div className="return-shipping-container">
                            {checkShippingOtiopn &&  
                              <ShippingOptions
                                shippingSelectedOption={shippingSelectedOption}
                                handleShippingChangeOption={handleShippingChangeOption}
                                rmaSelected={rmaSelected}
                              />
                            }

                            {shippingSelectedOption==="shipToDistribution" && 
                              <DistributionOptions
                                distributionSelectedOption={distributionSelectedOption}
                                handleDistributionChangeOption={handleDistributionChangeOption}
                                rmaSelected={rmaSelected}
                              />
                            }

                            {shippingSelectedOption==="dropOffAtStore" && 
                              <DropOffStore
                                distributionSelectedOption={distributionSelectedOption}
                                handleDistributionChangeOption={handleDistributionChangeOption}
                                rmaSelected={rmaSelected}
                                storeList={storeList}
                                isLoading={isLoader}
                                handleDropOffWarehouse={handleDropOffWarehouse}
                              />
                            }



                            {distributionSelectedOption==="purchasePrepaidShipping" && confirmBox===false && 
                              <BoxInfo
                                distributionSelectedOption={distributionSelectedOption}
                                handleDistributionChangeOption={handleDistributionChangeOption}
                                rmaSelected={rmaSelected}
                                handleGenerateShippingLabel={handleGenerateShippingLabel}
                                userData={userData}
                                totalItemPrice={totalItemPrice}
                                upsErrorMessage={upsErrorMessage}
                                isLoader={isLoader}
                                shippingType={shppingTypeVal}
                                handleConfirmationCancel={handleConfirmationCancel}
                                handleBoxeChange={handleBoxeChange}
                              />
                            }

                            {confirmBox && 
                              <BoxConfirm
                                distributionSelectedOption={distributionSelectedOption}
                                handleDistributionChangeOption={handleDistributionChangeOption}
                                rmaSelected={rmaSelected}
                                handleGenerateShippingLabel={handleGenerateShippingLabel}
                                boxResponseData={upsResponseData}
                                totalShippingCharge={upsTotalShippingCharge}
                                handleConfirmationCancel={handleConfirmationCancel}
                                handleUpsConfirmation={handleUpsConfirmation}
                                shippingType={shppingTypeVal}
                                totalItemPrice={totalItemPrice}
                              />
                            }

                             {distributionSelectedOption==="selfShipping" && 
                              <SelfShipping
                                distributionSelectedOption={distributionSelectedOption}
                                handleDistributionChangeOption={handleDistributionChangeOption}
                                rmaSelected={rmaSelected}
                                storeList={storeList}
                                isLoading={isLoader}
                                handleSelfShippingWarehouse={handleSelfShippingWarehouse}
                              />
                            }

                            {preSaveForLaterAlt &&
                                        <SaveForLaterConfirm
                                        handleSaveForLater={handleSaveForLater}
                                        />
                                        }
                          
                          </div>
                          
                        </div>
                       
                      </div>
                    </div>
                  </div>
                </div>
            </div>
            }
            

            <div className="rp-returns-cart-modal-actions">
              <div className="container-fluid">
                <div className="row">
                  <div className="col-3 d-flex-justify-content-start">
                    <Button
                      buttonClass="rp-returns-cart-modal-button rp-returns-cart-modal-actions-goback-btn nolined"
                      label={t('common.goBack')}
                      textTransform="uppercase"
                      action={closeModal}
                    />
                  </div>
                  <div className="col-9 d-flex justify-content-end" ref={ref}>
                    <Button
                      action={shppingTypeVal===""?handleSaveForLater:handlePreSaveForLater}
                      buttonClass="rp-returns-cart-modal-button outlined"
                      label={t('common.saveForLater')}
                      textTransform="uppercase"
                      disabled={isDisabledLater()}
                    />

                    <Button
                      action={handleSubmitNow}
                      buttonClass="rp-returns-cart-modal-button filled"
                      label={t('common.submitNow')}
                      textTransform="uppercase"
                      disabled={isDisabled()}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default ReturnsCartModal;
